<div mat-dialog-title>
  <div class="h4 mb-0">{{title}}</div>
  <button mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div mat-dialog-content class="pb-0">
  <div class="d-flex">
    <form [formGroup]="form" class="w-100">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label i18n="@@shared.commentModal.lblComment">Comment</mat-label>
        <textarea
          data-testId="comment-text-area"
          matInput
          formControlName="comment"
          cdkFocusInitial
          maxlength="{{data.context.additionalData.maxLength}}"
        ></textarea>
      </mat-form-field>
    </form>
  </div>
</div>
<div mat-dialog-actions class="d-flex">
  <div *ngIf="data.context.allowEditing; else readOnlyAction" class="d-flex">
    <button data-testId="save-comment" mat-flat-button color="primary" (click)="onDone()" cdkFocusInitial>
      <mat-icon svgIcon="check"></mat-icon>
      <span>{{staticMessage.DoneButton | staticMessage}}</span>
    </button>
    <button data-testId="cancel-comment" mat-button color="primary" (click)="onCancel()">
      {{staticMessage.CancelButton | staticMessage}}
    </button>
  </div>

  <ng-template #readOnlyAction>
    <button data-testId="cancel-comment" mat-flat-button color="primary" (click)="onCancel()">
      {{staticMessage.CloseButton | staticMessage}}
    </button>
  </ng-template>
</div>
